<template>
  <v-app>
    <v-content>
      <router-view v-title="title" ></router-view>
    </v-content>
    <v-content>

      <v-card class="mx-auto content-personal" max-width="70%" style="padding:30px; margin:30px;" :flat='true'>
        <v-row v-if='need_update_profile' class='ma-2'>
            <v-alert
              icon="mdi-shield-lock-outline"
              width='100%'
              outlined
              type="warning"
            >
               {{$t('update_personal_data')}}
            </v-alert>
          </v-row>
        <div class="content-personal__header d-flex justify-space-between align-start">
          <v-chip
            class="mr-2 ml-2"
            dark
            outlined
            label
            style="max-width:168px; margin-bottom:20px;"
            @click="locationUser('/user')"
            color="#15336d">
            <v-icon left>mdi-arrow-left</v-icon>
            {{$t('list-proposals')}}
          </v-chip>

          <div class="switch d-flex align-start">
            <h1 class="switch__current-lang">RU</h1>
            <v-switch :color="$mainColor" v-model="changeLanguage" label="EN"></v-switch>
          </div>
        </div>
        <v-card-text>

          <v-row>

            <v-list>
              <v-list-item>
                <v-list-item-avatar
                  height="100px"
                  width="100px"
                  class="avatar">
                  <v-img v-bind:src="avatar_img"></v-img>
                  <div
                    class="description-upload-photo">
                     <span>{{$t('PersonalData.upload_photo')}}</span>
                    <input
                      type="file"
                      @change="onUploadFile"
                      :name="$t('PersonalData.upload_photo')"
                      accept="image/gif, image/jpeg, image/png"
                    />
                  </div>
                </v-list-item-avatar>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-skeleton-loader
                    :loading="loading"
                    height="94"
                    type="list-item-two-line">
                    <v-list-item-title
                      class="title"> {{last_name}} {{name}}
                    </v-list-item-title>
                    <v-list-item-subtitle>{{email}}</v-list-item-subtitle>

                    <template>
                      <v-chip
                        v-for="(item, index) in roles"
                        :key="index"
                        class=""
                        x-small>
                        {{item.name}}
                      </v-chip>
                    </template>
                  </v-skeleton-loader>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-skeleton-loader
                :loading="loading"
                height="94"
                type="list-item-two-line">
              <v-text-field
              v-model="last_name"
              :label="surNameLabel"
              required></v-text-field>
              </v-skeleton-loader>
            </v-col>
            <v-col cols="12" md="4">
              <v-skeleton-loader
                :loading="loading"
                height="94"
                type="list-item-two-line">
                <v-text-field
                  v-model="name"
                  :label="nameLabel"
                  required>
                </v-text-field>
              </v-skeleton-loader>
            </v-col>
            <v-col cols="12" md="4">
              <v-skeleton-loader
                :loading="loading"
                height="94"
                type="list-item-two-line">
              <v-text-field
                  v-model="middle_name"
                  :label="patronymicLabel" required>
               </v-text-field>
              </v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols='12'>
              <v-skeleton-loader
                :loading="loading"
                height="94"
                type="list-item-two-line">
              <v-autocomplete
                v-model="currentOrganization"
                :items="fullOrganizationArray"
                item-text="name"
                item-value="id"
                :label="scienceOrganizationLabel"
                prepend-icon="mdi-city"
              ></v-autocomplete>
              </v-skeleton-loader>
            </v-col>
            <v-col cols='6'>
              <v-skeleton-loader
                :loading="loading"
                height="94"
                type="list-item-two-line">
                <v-text-field
                  v-model="phone"
                  :label="phoneLabel"
                  required
                  prepend-icon="mdi-phone"></v-text-field>
              </v-skeleton-loader>
            </v-col>
             <v-col cols="12" lg="6">
               <v-skeleton-loader
                :loading="loading"
                height="94"
                type="list-item-two-line">
              <v-autocomplete
                v-model="currentDegree"
                :items="fullDegreeArray"
                item-text="title"
                item-value="id"
                :label='scienceDegreeLabel'
                prepend-icon="mdi-badge-account-outline">
              </v-autocomplete>
              </v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" lg="6">
              <v-menu
                v-model="birthDay"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto">
                <template v-slot:activator="{ on }">
                  <v-skeleton-loader
                    :loading="loading"
                    height="94"
                    type="list-item-two-line">
                    <v-text-field
                      v-model="computedDateFormatted"
                      :label="birthDayLabel"
                      :hint="hint"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      ></v-text-field>
                    </v-skeleton-loader>
                </template>
                <v-date-picker
                  v-model="new_date"
                  no-title
                  @input="birthDay = false"
                  locale='ru-RU'
                  first-day-of-week=1
                  scrollable
                  min="1925-01-01"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" lg="6"></v-col>

            <!--v-col cols="12" lg="6">
              <v-skeleton-loader
                :loading="loading"
                height="94"
                type="list-item-two-line">
                <v-autocomplete
                v-model="currentRang"
                :items="fullRangArray"
                item-text="title"
                item-value="id"
                :label="scienceRankLabel"
                prepend-icon="mdi-badge-account-alert"
              ></v-autocomplete>
              </v-skeleton-loader>
            </v-col-->
          </v-row>
          <v-row>
            <v-col style="text-align: right;">
              <p>Уведомления по email : </p>
            </v-col>
            <v-col class="pa-0">
              <v-checkbox
                class="ma-0"
                v-model="personal_email_on"
                label="Персональные уведомления"
              ></v-checkbox>
              <v-checkbox
                class="ma-0"
                v-model="mass_email_on"
                label="Массовые рассылки"
              ></v-checkbox>
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-btn
            color="#16336e"
            dark
            outlined
            label
            class="mr-4 ml-2"
            :loading="loaded"
            @click="save_btn"
          >{{$t('save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-content>
  </v-app>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required, maxLength, email } from 'vuelidate/lib/validators';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import user from '../assets/user.png';

export default {
  mounted() {
    this.changeLanguage = localStorage.language !== 'ru';
    this.uploadDataUser(this.GETTERS_APP_LANGUAGE_NTRANSLATE);
  },
  name: 'PersonalData',
  mixins: [validationMixin],
  validations: {
    name: { required, maxLength: maxLength(10) },
    email: { required, email },
    select: { required },
    checkbox: {
      checked(val) {
        return val;
      },
    },
  },
  data: () => ({
    currentRang: null,
    title: 'This will be the title',
    boilerplate: true,
    loading: false,
    need_update_profile: false,
    name: '',
    middle_name: '',
    loginChecked: true,
    last_name: '',
    roles: [],
    avatar_img: user,
    email: '',
    phone: '',
    changeLanguage: '',
    model: null,
    academic_rank: null,
    currentDegree: null,
    currentOrganization: null,
    new_date: null,
    birthDay: false,
    head_info: '',
    rules: {
      required: (value) => !!value || 'Required.',
      min: (v) => v.length >= 8 || 'Min 8 characters',
    },
    edit: false,
    rang: null,
    organizations: null,
    fullRangArray: null,
    fullDegreeArray: null,
    fullOrganizationArray: [],
    loaded: false,
    personal_email_on: true,
    mass_email_on: true,
  }),
  components: {
  },
  watch: {
    changeLanguage(newLang) {
      if (newLang) {
        this.LANGUAGE_SWITCH({
          id: localStorage.isLoggedIn,
          language: 'en',
        })
          .then(() => {
            this.$i18n.locale = 'en';
            this.uploadDataUser('en');
          });
      } else {
        this.LANGUAGE_SWITCH({
          id: localStorage.isLoggedIn,
          language: 'ru',
        })
          .then(() => {
            this.$i18n.locale = 'ru';
            this.uploadDataUser('ru');
          });
      }
    },
    GETTERS_PHOTO_USER(val) {
      this.avatar_img = val;
    },
  },
  computed: {
    ...mapGetters([
      'GETTERS_LOGIN',
      'GETTERS_PHOTO_USER',
      'GETTERS_APP_LANGUAGE',
      'GETTERS_APP_LANGUAGE_NTRANSLATE',
    ]),
    checkboxErrors() {
      const errors = [];
      if (!this.$v.checkbox.$dirty) return errors;
      return errors;
    },
    computedDateFormatted() {
      return this.formatDate(this.new_date);
    },
    surNameLabel() {
      return this.$t('sur-name-label');
    },
    scienceOrganizationLabel() {
      return this.$t('organization-label');
    },
    nameLabel() {
      return this.$t('name-label');
    },
    patronymicLabel() {
      return this.$t('patronymic-label');
    },
    hint() {
      return this.$t('hint-bd');
    },
    birthDayLabel() {
      return this.$t('bd-label');
    },
    phoneLabel() {
      return this.$t('phone-label');
    },
    scienceRankLabel() {
      return this.$t('rank-label');
    },
    scienceDegreeLabel() {
      return this.$t('degree-label');
    },
    selectErrors() {
      const errors = [];
      if (!this.$v.select.$dirty) return errors;
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      return errors;
    },

  },
  created() {
    this.loading = true;
  },
  methods: {
    ...mapActions([
      'LOAD_PHOTO',
      'UPDATE_INDIVIDUAL',
      'LANGUAGE_SWITCH',
      'GET_ACADEMIC_DEGREE',
      'GET_ACADEMIC_RANK',
      'ORGANIZATION',
      'GET_PERSONAL_DATA',
      'logged',
    ]),
    ...mapMutations(['SET_APP_LANGUAGE']),
    locationUser(url) {
      window.location.href = url;
    },

    parserDate(date, type) {
      let getYear = null;
      let getMonth = null;
      let getDay = null;
      if (type) {
        getDay = Number(date.slice(3, 5));
        getMonth = Number(date.slice(0, 2) - 1);
        getYear = Number(date.slice(6));
      } else {
        getYear = Number(date.slice(0, 4));
        getMonth = Number(date.slice(5, 7) - 1);
        getDay = Number(date.slice(8));
      }

      const result = new Date(getYear, getMonth, getDay);
      result.setHours(15);
      result.setMinutes(0);
      return result.toISOString();
    },

    parserString(date) {
      const idx = date.indexOf('T');
      return date.slice(0, idx);
    },

    async uploadDataUser(lang) {
      try {
        await this.logged({ token: localStorage.token });
        const rang = await this.GET_ACADEMIC_RANK(lang);
        const degree = await this.GET_ACADEMIC_DEGREE(lang);

        const organizations = await this.ORGANIZATION();

        this.fullRangArray = rang.data;
        this.fullOrganizationArray = organizations.data;
        this.fullDegreeArray = degree.data;

        this.rang = rang.data.map((item) => item.title);
        this.organizations = organizations.data.map((item) => item.name);

        if (this.GETTERS_LOGIN) {
          this.edit = true;
          const data = await this.GET_PERSONAL_DATA();
          this.email = data.username;
          this.roles = data.profiles[0].role;
          this.last_name = data.profiles[0].individual.last_name;
          this.phone = data.profiles[0].individual.phone_number;
          this.name = data.profiles[0].individual.first_name;
          this.middle_name = data.profiles[0].individual.middle_name || '';
          this.currentDegree = data.profiles[0].individual.academic_degree;
          this.currentRang = data.profiles[0].individual.academic_rank;
          this.currentOrganization = data.profiles[0].individual.organization;
          this.need_update_profile = data.profiles[0].individual.update_personal_data;
          const currentDate = data.profiles[0].individual.birth_date
            && this.parserString(data.profiles[0].individual.birth_date);
          this.new_date = currentDate || '';
          this.avatar_img = data.profiles[0].individual.photo
            ? data.profiles[0].individual.photo : this.avatar_img;

          this.mass_email_on = data.profiles[0].individual.mass_email_on;
          this.personal_email_on = data.profiles[0].individual.personal_email_on;
          }
        this.loading = false;
      } catch (ex) {
        this.loginChecked = false;
        console.log('ex ---> ', ex);
      }
    },
    async onUploadFile(e) {
      const file = e.target.files || e.dataTransfer.files;
      console.log('ewwe', file);
      const blob = new Blob([file[0]], { type: ['image/jpg', 'image/jpeg', 'image/png'] });
      const files = new FormData();
      files.append('img', blob);
      files.append('id', this.GETTERS_LOGIN);
      files.append('name', file[0].name);

      await this.LOAD_PHOTO(files)
        .then((res) => {
          this.$messageHelper(this.$t('PersonalData.photo_uploaded'), 'success', 3000);
        });
    },
    get_params() {
      return {
        id: this.GETTERS_LOGIN,
        first_name: this.name,
        last_name: this.last_name,
        middle_name: this.middle_name,
        birth_date: this.parserDate(this.new_date),
        phone_number: this.phone,
        // academic_rank: this.currentRang,
        academic_degree: this.currentDegree,
        organization: this.currentOrganization,
        personal_email_on: this.personal_email_on,
        mass_email_on: this.mass_email_on,
      };
    },
    async save_btn() {
      this.boilerplate = true;
      this.loaded = true;

      await this.UPDATE_INDIVIDUAL(this.get_params())
        .then((res) => {
          if (res.status === 200) this.$messageHelper(this.$t('PersonalData.data_saved'), 'success', 3000);
          this.loaded = false;
          this.need_update_profile = false;
        })
        .catch((e) => {
          this.dialog = true;
          this.loaded = false;
          this.head_info = this.$t('error');
          this.info = `${e}`;
          this.$messageHelper(`${e}`, 'error', 3000);
        });
    },
    clear() {
      this.$v.$reset();
      this.name = '';
      this.email = '';
      this.select = null;
      this.checkbox = false;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },

    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
  },
};
</script>
<style lang="scss" scoped>
  .description-upload-photo{
    display: none;
    position: absolute;
    background: black;
    color: white;
    opacity: 0.65;
    top:45px;
  }
  .avatar:hover .description-upload-photo{
    display: block;
  }
  .upload{
    opacity: 0;
  }
  .description-photo{
    top:-20px;
  }
  input[type=file] {
    opacity: 0;
    cursor: pointer;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .content-personal{
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgba(0, 0, 0, 0.87);
}

@media screen and (max-width:767px) {
  .content-personal {
    max-width: 90% !important;
  }
  .content-personal__header {
    flex-direction: column;
  }
}
</style>
